/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_Tablist_LabelInputs */

const en_home_bench_tablist_label = /** @type {(inputs: Home_Bench_Tablist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example business tasks`)
};

const lv_home_bench_tablist_label = /** @type {(inputs: Home_Bench_Tablist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biznesa uzdevumu piemēri`)
};

/**
* | output |
* | --- |
* | "Example business tasks" |
*
* @param {Home_Bench_Tablist_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_tablist_label = /** @type {((inputs?: Home_Bench_Tablist_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_Tablist_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_tablist_label(inputs)
	return en_home_bench_tablist_label(inputs)
});